import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import permissions from "app/permissions";
import { SEMESTERS, StudentServicePath } from "utils/constants";
import ListAcademicSemesters from "./List";
import CreateAcademicSemesters from "./Create";
import EditAcademicSemester from "./Edit";

export const resources = {
  isMenu: true,
  icon: <AssignmentLateIcon />,
  title: "Семестри",
  name: StudentServicePath + SEMESTERS, //fe path
  list: <ListAcademicSemesters onlySemesters={true} />,
  create: <CreateAcademicSemesters />,
  createPermission: permissions.canCreateAcademicSessions,
  edit: <EditAcademicSemester />,
  editPermission: permissions.canUpdateAcademicSessions,
  // show: <ShowSessionExam />,
  // showPermission: permissions.canPreviewSessionExams,
  permission: permissions.canPreviewAcademicSessions,
};
